import { View } from "react-native";
import {
  Ban,
  CircleHelp,
  ShieldCheck,
  Sparkles,
  TrendingUp,
} from "lucide-react-native";
import type { LucideIcon } from "lucide-react-native";
import type { ContentBlock } from "@src/packages/content";
import { useLocale, useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../../onboarding/theme";
import THERAPY_ILLUSTRATIONS from "../../../assets/images/therapies";
import AccessGridCard, { AccessGridCardPill } from "./AccessGridCard";

type TherapyCardProps = {
  therapy: ContentBlock<"therapy">;
  onPress: (therapy: ContentBlock<"therapy">) => void;
};

type EvidenceStrength = ContentBlock<"therapy">["body"]["evidenceStrength"];

const EVIDENCE_ICON: Record<EvidenceStrength, LucideIcon> = {
  strong: ShieldCheck,
  moderate: TrendingUp,
  emerging: Sparkles,
  mixed: CircleHelp,
  debunked: Ban,
};

export default function TherapyCard({ therapy, onPress }: TherapyCardProps) {
  const t = useTranslations();
  const { locale } = useLocale();
  const body =
    locale === "fr" && therapy.bodyFr ? therapy.bodyFr : therapy.body;
  const illustration = THERAPY_ILLUSTRATIONS[therapy.id];
  const evidenceIcon = EVIDENCE_ICON[body.evidenceStrength];
  const evidenceLabel = t(
    `access.therapies.evidence_filter.${body.evidenceStrength}`,
  );
  const benefit = body.expectations?.canExpect[0] ?? "";

  return (
    <AccessGridCard
      title={body.name}
      description={benefit}
      imageSource={illustration}
      imageStyle={{ width: 64, height: 64 }}
      onPress={() => onPress(therapy)}
      action="therapy_card"
      fallbackVisual={
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 20,
            backgroundColor: `${EMBER.colors.teal}14`,
          }}
        />
      }
      tags={
        <>
          {body.headlineStat ? (
            <AccessGridCardPill label={body.headlineStat} />
          ) : null}
          <AccessGridCardPill label={evidenceLabel} icon={evidenceIcon} />
        </>
      }
    />
  );
}
